import { NotificationSettings } from '@/screens/notification-settings';

export default function NotificationSettingsScreen() {
  return <NotificationSettings />;
}
